import DataLayerService from "../../DataLayerService.js";

const datalayerService = new DataLayerService();

/**
 * Sendet einen fertig aufgebauten dl-event Payload in den DataLayer.
 *
 * Wird sowohl vom direkten Pfad (dl-event-handler) als auch vom verzögerten Pfad
 * (deferred-dl-event) verwendet.
 *
 * @param {Object} payload - Payload aus buildDlEventPayload()
 * @param {string} payload.eventName - Event-Name aus dem dl-event Attribut
 * @param {Object} payload.params - Event-Level Parameter
 * @param {Array<Object>} [payload.items] - Items, nur bei Ecommerce-Events gesetzt
 * @returns {boolean} true wenn gepusht wurde
 */
export function pushDlEventPayload(payload) {
	const { eventName, params, items } = payload;

	if (items) {
		datalayerService.pushEvent(eventName, params, items);
	} else {
		datalayerService.pushEvent(eventName, params);
	}

	return true;
}
